import { Routes } from '@angular/router';

import { applicationRoutes, fallbackRoute } from './app.routes.shared';
import {
  CONTENT_PACKAGE_SOURCE,
} from './services/content-package-source';
import { previewContentPackageSourceFactory } from './services/preview-content-package-source';
import { CourseContentService } from './services/course-content.service';
import { GlossaryService } from './services/glossary.service';
import {
  LESSON_INTERACTION_STATE,
  PreviewLessonInteractionState,
} from './services/lesson-interaction-state';

const editorialPreviewRoute: Routes[number] = {
  path: 'redaktionsvorschau/:bundleId/kurse/:courseId/module/:moduleId/lektion/:lessonId',
  providers: [
    CourseContentService,
    GlossaryService,
    PreviewLessonInteractionState,
    {
      provide: CONTENT_PACKAGE_SOURCE,
      useFactory: previewContentPackageSourceFactory,
    },
    {
      provide: LESSON_INTERACTION_STATE,
      useExisting: PreviewLessonInteractionState,
    },
  ],
  loadComponent: () => import('./pages/editorial-preview/editorial-preview.component')
    .then((module) => module.EditorialPreviewComponent),
};

export const routes: Routes = [
  ...applicationRoutes,
  editorialPreviewRoute,
  fallbackRoute,
];
